export const timeoutLabels = {
  warningHeaderAAL: 'It looks like your session is about to expire.',
  warningHeaderNSE: 'Just a heads up that your current session will expire in #TimeLeft# minutes because of inactivity.',
  warningMessageAAL: 'You will be logged out of your session in #TimeLeft#. Do you want to continue with your session?',
  warningMessageNSE: "You'll lose the items in your cart if your session expires.",
  timeoutHeaderAAL: 'Oops. Looks like your session has timed out.',
  timeoutHeaderNSE: 'Oops. Looks like your session expired because of inactivity.',
  timeoutMessageAAL: "Your session isn't active anymore because of inactivity. Don't worry though, just log back in and start a new one.",
  timeoutMessageNSE: "You'll have to start your transaction over.",
  logInCTA: 'Log in',
  thankYouCTA: 'Ok, thank you',
  continueCTA: 'Continue',
  continueSessionCTA: 'Continue Session',
};
